// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color-box[data-v-2c14a745]{width:14px;height:14px;display:inline-block;border:1px solid rgba(0,0,0,.1);border-radius:4px}.ltr-input[data-v-2c14a745] textarea{direction:ltr;text-align:left}", ""]);
// Exports
module.exports = exports;
